/**
 * Returns
 * startDate - Today - 6 days (Last 7th day) 0h0m0s
 * endDate - Today 23:59:59
 */
export const getLast7DaysStartAndEndDate = () => {
  const today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  const last7Days = new Date(today.getTime());
  last7Days.setDate(last7Days.getDate() - 6);
  const startDate = last7Days.getTime();
  const endDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    23,
    59,
    59
  ).getTime();
  return { startDate, endDate };
};


export const validateDateFormat = (dateString: string): [boolean, string?] => {
  // Date regex YYYY-MM-DD
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;
  // validate secondoryValue
  if (dateString && !datePattern.test(dateString)) {
    return [false, "Please enter a valid date as per format YYYY-MM-DD"];
  }
  // validate MM and DD for secondoryValue
  const dateParts = dateString?.split("-");
  if (dateParts && dateParts.length === 3) {
    const month = parseInt(dateParts[1], 10);
    const day = parseInt(dateParts[2], 10);
    if (month < 1 || month > 12 || day < 1 || day > 31) {
      return [false, "Please enter a valid date"];
    }
    return [true, undefined];
  }

  return [false, "Invalid date format"];
}

export const getNowInTimezone = (timezone?: string): Date => {
  if (!timezone) return new Date();
  try {
    return new Date(new Date().toLocaleString("en-US", { timeZone: timezone }));
  } catch {
    return new Date();
  }
};

export const getDatePartsInTimezone = (
  timezone?: string
): { day: number; month: number; year: number } => {
  const now = getNowInTimezone(timezone);
  return {
    day: now.getDate(),
    month: now.getMonth(),
    year: now.getFullYear(),
  };
};
